// extracted by mini-css-extract-plugin
export default {"NewRoconCardContainer":"NewRoconCard_NewRoconCardContainer__b7N1Q","icon":"NewRoconCard_icon__mZyTH","header":"NewRoconCard_header__I2eAY","title":"NewRoconCard_title__eVk1P"};